import React from "react";
import { StyleSheet, View } from "react-native";
import BouncyCheckbox from "react-native-bouncy-checkbox";

import {
  COLORS,
  COMMON_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

interface Props {
  isSelected: boolean;
  filterName: string;
  filterId: string;
  onChange: (isChecked: boolean) => void;
}

const FilterListItem = ({ isSelected, filterName, onChange }: Props) => {
  return (
    <View style={[COMMON_STYLES.pv1]}>
      <BouncyCheckbox
        isChecked={isSelected}
        onPress={onChange}
        text={filterName}
        size={20}
        fillColor={COLORS.primary100}
        iconStyle={styles.checkbox}
        innerIconStyle={styles.checkbox}
        textStyle={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.BASE,
          styles.checkBoxText,
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  checkbox: {
    borderRadius: 3,
  },
  checkBoxText: {
    textDecorationLine: "none",
    color: COLORS.neutral90,
  },
});

export default FilterListItem;
